import fetch from "isomorphic-fetch";
import { createReduxStore, register } from "@wordpress/data";
import { each, filter } from "lodash";

function uuidv4() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

const DEFAULT_STATE = {
  playlistsModal: {
    open: false,
  },
  playingTrack: "",
  addingTrack: "",
  energyDisplayColumn: "energy",
  shapeDisplayColumn: "icon",
  playlists: {},
  selectedTracks: [],
  tracks: [],
};

// populate from localStorage, if exists
const localStoragePlaylists = localStorage.getItem("playlists");
if (localStoragePlaylists) {
  DEFAULT_STATE.playlists = JSON.parse(localStoragePlaylists);
}

var AudioContext = window.AudioContext || window.webkitAudioContext || null;
var audioCtx = new AudioContext();
window.HIFI_APP.audioContext = audioCtx;

const actions = {
  setEnergyDisplayColumn(column) {
    return {
      type: "SET_ENERGY_DISPLAY_COLUMN",
      column,
    };
  },

  setShapeDisplayColumn(column) {
    return {
      type: "SET_SHAPE_DISPLAY_COLUMN",
      column,
    };
  },

  setPlayingTrack(trackKey) {
    return {
      type: "SET_PLAYING_TRACK",
      trackKey,
    };
  },

  setTracks(tracks) {
    return {
      type: "SET_TRACKS",
      tracks,
    };
  },

  setAddingTrack(trackKey) {
    return {
      type: "SET_ADDING_TRACK",
      trackKey,
    };
  },

  setPlaylistsModalOpen(isOpen) {
    return {
      type: "SET_PLAYLISTS_MODAL_OPEN",
      isOpen,
    };
  },

  addNewPlaylist(title) {
    return {
      type: "ADD_NEW_PLAYLIST",
      title,
    };
  },

  removePlaylist(playlistId) {
    return {
      type: "REMOVE_PLAYLIST",
      playlistId,
    };
  },

  addTrackToPlaylist(track, playlistId) {
    return {
      type: "ADD_TRACK_TO_PLAYLIST",
      track,
      playlistId,
    };
  },

  removeTrackFromPlaylist(trackKey, playlistId) {
    return {
      type: "REMOVE_TRACK_FROM_PLAYLIST",
      trackKey,
      playlistId,
    };
  },

  addTrackToSelected(track, trackKey) {
    return {
      type: "ADD_TRACK_TO_SELECTED",
      track,
      trackKey,
    };
  },

  removeTrackFromSelected(trackKey) {
    return {
      type: "REMOVE_TRACK_FROM_SELECTED",
      trackKey,
    };
  },

  removeAllFromSelected() {
    return {
      type: "REMOVE_ALL_FROM_SELECTED",
    };
  },

  addAllToSelected() {
    return {
      type: "ADD_ALL_TO_SELECTED",
    };
  },
};

const store = createReduxStore("hifi", {
  reducer(state = DEFAULT_STATE, action) {
    switch (action.type) {
      case "SET_PLAYLISTS_MODAL_OPEN":
        return {
          ...state,
          playlistsModal: {
            ...state.playlistsModal,
            open: action.isOpen,
          },
        };
      case "SET_PLAYING_TRACK":
        return {
          ...state,
          playingTrack: action.trackKey,
        };
      case "SET_TRACKS":
        return {
          ...state,
          tracks: action.tracks,
        };
      case "SET_ADDING_TRACK":
        return {
          ...state,
          addingTrack: action.trackKey,
        };
      case "SET_ENERGY_DISPLAY_COLUMN":
        return {
          ...state,
          energyDisplayColumn: action.column,
        };
      case "SET_SHAPE_DISPLAY_COLUMN":
        return {
          ...state,
          shapeDisplayColumn: action.column,
        };
      case "ADD_NEW_PLAYLIST": {
        const id = uuidv4();
        const newState = {
          ...state,
          playlists: {
            ...state.playlists,
            [id]: {
              id,
              title: action.title,
              tracks: [],
            },
          },
        };

        // todo, do this persistance better
        localStorage.setItem("playlists", JSON.stringify(newState.playlists));

        return newState;
      }
      case "REMOVE_PLAYLIST": {
        const newState = {
          ...state,
          playlists: {
            ...filter(
              state.playlists,
              (playlist) => playlist.id !== action.playlistId
            ),
          },
        };

        // todo, do this persistance better
        localStorage.setItem("playlists", JSON.stringify(newState.playlists));

        return newState;
      }
      case "ADD_TRACK_TO_PLAYLIST": {
        const newState = {
          ...state,
          playlists: {
            ...state.playlists,
            [action.playlistId]: {
              ...state.playlists[action.playlistId],
              tracks: {
                ...state.playlists[action.playlistId].tracks,
                [action.track.trackKey]: action.track,
              },
            },
          },
        };

        // todo, do this persistance better
        localStorage.setItem("playlists", JSON.stringify(newState.playlists));

        return newState;
      }
      case "REMOVE_TRACK_FROM_PLAYLIST": {
        const newState = {
          ...state,
          playlists: {
            ...state.playlists,
            [action.playlistId]: {
              ...state.playlists[action.playlistId],
              tracks: {
                ...filter(
                  state.playlists[action.playlistId].tracks,
                  (track) => track.trackKey !== action.trackKey
                ),
              },
            },
          },
        };

        // todo, do this persistance better
        localStorage.setItem("playlists", JSON.stringify(newState.playlists));

        return newState;
      }
      case "ADD_TRACK_TO_SELECTED": {
        const newState = {
          ...state,
          selectedTracks: {
            ...state.selectedTracks,
            [action.trackKey]: action.track,
          },
        };

        return newState;
      }
      case "REMOVE_TRACK_FROM_SELECTED": {
        const selectedTracks = {
          ...state.selectedTracks,
        };

        delete selectedTracks[action.trackKey];

        const newState = {
          ...state,
          selectedTracks: {
            ...selectedTracks,
          },
        };

        return newState;
      }
      case "ADD_ALL_TO_SELECTED": {
        const { tracks } = state;

        let selectedTracks = {};
        tracks.forEach((track) => {
          let versionNumber = 0;
          track.versions.forEach((version) => {
            versionNumber++;
            selectedTracks[`${track.objectID}-${versionNumber}`] = track;
          });
        });

        const newState = {
          ...state,
          selectedTracks,
        };

        return newState;
      }
      case "REMOVE_ALL_FROM_SELECTED": {
        const newState = {
          ...state,
          selectedTracks: {},
        };

        return newState;
      }
      default:
        return state;
    }
  },

  actions,

  selectors: {
    getPlaylistsModalOpen(state, filter) {
      const { playlistsModal } = state;

      return playlistsModal.open;
    },
    getPlayingTrack(state) {
      const { playingTrack } = state;

      return playingTrack;
    },
    getTracks(state) {
      const { tracks } = state;

      return tracks;
    },
    getAddingTrack(state) {
      const { addingTrack } = state;

      return addingTrack;
    },
    getEnergyDisplayColumn(state) {
      const { energyDisplayColumn } = state;

      return energyDisplayColumn;
    },
    getShapeDisplayColumn(state) {
      const { shapeDisplayColumn } = state;

      return shapeDisplayColumn;
    },
    getPlaylists(state) {
      const { playlists } = state;

      return playlists;
    },
    getSelectedTracks(state) {
      const { selectedTracks } = state;

      return selectedTracks;
    },
  },

  controls: {},

  resolvers: {},
});

register(store);
